export const ILLER = [
  {
    id: 1,
    name: 'Adana',
    ilceler: [
      'Aladağ', 'Ceyhan', 'Çukurova', 'Feke', 'İmamoğlu', 'Karaisalı',
      'Karataş', 'Kozan', 'Pozantı', 'Saimbeyli', 'Sarıçam', 'Seyhan',
      'Tufanbeyli', 'Yumurtalık', 'Yüreğir'
    ]
  },
  {
    id: 2,
    name: 'Adıyaman',
    ilceler: [
      'Adıyaman Merkez', 'Besni', 'Çelikhan', 'Gerger', 'Gölbaşı', 'Kahta',
      'Samsat', 'Sincik', 'Tut'
    ]
  },
  {
    id: 3,
    name: 'Afyonkarahisar',
    ilceler: [
      'Afyonkarahisar Merkez', 'Başmakçı', 'Bayat', 'Bolvadin', 'Çay', 'Çobanlar',
      'Dazkırı', 'Dinar', 'Emirdağ', 'Evciler', 'Hocalar', 'İhsaniye',
      'İscehisar', 'Kızılören', 'Sandıklı', 'Sinanpaşa', 'Sultandağı', 'Şuhut'
    ]
  },
  {
    id: 4,
    name: 'Ağrı',
    ilceler: [
      'Ağrı Merkez', 'Diyadin', 'Doğubayazıt', 'Eleşkirt', 'Hamur', 'Patnos',
      'Taşlıçay', 'Tutak'
    ]
  },
  {
    id: 5,
    name: 'Amasya',
    ilceler: [
      'Amasya Merkez', 'Göynücek', 'Gümüşhacıköy', 'Hamamözü', 'Merzifon',
      'Suluova', 'Taşova'
    ]
  },
  {
    id: 6,
    name: 'Ankara',
    ilceler: [
      'Altındağ', 'Ayaş', 'Bala', 'Beypazarı', 'Çamlıdere', 'Çankaya',
      'Çubuk', 'Elmadağ', 'Etimesgut', 'Evren', 'Gölbaşı', 'Güdül',
      'Haymana', 'Kalecik', 'Kahramankazan', 'Keçiören', 'Kızılcahamam',
      'Mamak', 'Nallıhan', 'Polatlı', 'Pursaklar', 'Sincan', 'Şereflikoçhisar',
      'Yenimahalle'
    ]
  },
  {
    id: 7,
    name: 'Antalya',
    ilceler: [
      'Aksu', 'Alanya', 'Akseki', 'Demre', 'Döşemealtı', 'Elmalı',
      'Finike', 'Gazipaşa', 'Gündoğmuş', 'İbradı', 'Kaş', 'Kemer',
      'Kepez', 'Konyaaltı', 'Korkuteli', 'Kumluca', 'Manavgat', 'Muratpaşa',
      'Serik'
    ]
  },
  {
    id: 8,
    name: 'Artvin',
    ilceler: [
      'Ardanuç', 'Arhavi', 'Artvin Merkez', 'Borçka', 'Hopa', 'Kemalpaşa',
      'Murgul', 'Şavşat', 'Yusufeli'
    ]
  },
  {
    id: 9,
    name: 'Aydın',
    ilceler: [
      'Bozdoğan', 'Buharkent', 'Çine', 'Didim', 'Efeler', 'Germencik',
      'İncirliova', 'Karacasu', 'Karpuzlu', 'Koçarlı', 'Köşk', 'Kuşadası',
      'Kuyucak', 'Nazilli', 'Söke', 'Sultanhisar', 'Yenipazar'
    ]
  },
  {
    id: 10,
    name: 'Balıkesir',
    ilceler: [
      'Altıeylül', 'Ayvalık', 'Balya', 'Bandırma', 'Bigadiç', 'Burhaniye',
      'Dursunbey', 'Edremit', 'Erdek', 'Gömeç', 'Gönen', 'Havran',
      'İvrindi', 'Karesi', 'Kepsut', 'Manyas', 'Marmara', 'Savaştepe',
      'Sındırgı', 'Susurluk'
    ]
  },
  {
    id: 11,
    name: 'Bilecik',
    ilceler: [
      'Bilecik Merkez', 'Bozüyük', 'Gölpazarı', 'İnhisar', 'Osmaneli',
      'Pazaryeri', 'Söğüt', 'Yenipazar'
    ]
  },
  {
    id: 12,
    name: 'Bingöl',
    ilceler: [
      'Adaklı', 'Bingöl Merkez', 'Genç', 'Karlıova', 'Kiğı', 'Solhan',
      'Yayladere', 'Yedisu'
    ]
  },
  {
    id: 13,
    name: 'Bitlis',
    ilceler: [
      'Adilcevaz', 'Ahlat', 'Bitlis Merkez', 'Güroymak', 'Hizan', 'Mutki',
      'Tatvan'
    ]
  },
  {
    id: 14,
    name: 'Bolu',
    ilceler: [
      'Bolu Merkez', 'Dörtdivan', 'Gerede', 'Göynük', 'Kıbrıscık',
      'Mengen', 'Mudurnu', 'Seben', 'Yeniçağa'
    ]
  },
  {
    id: 15,
    name: 'Burdur',
    ilceler: [
      'Ağlasun', 'Altınyayla', 'Bucak', 'Burdur Merkez', 'Çavdır', 'Çeltikçi',
      'Gölhisar', 'Karamanlı', 'Kemer', 'Tefenni', 'Yeşilova'
    ]
  },
  {
    id: 16,
    name: 'Bursa',
    ilceler: [
      'Büyükorhan', 'Gemlik', 'Gürsu', 'Harmancık', 'İnegöl', 'İznik',
      'Karacabey', 'Keles', 'Kestel', 'Mudanya', 'Mustafakemalpaşa', 'Nilüfer',
      'Orhaneli', 'Orhangazi', 'Osmangazi', 'Yenişehir', 'Yıldırım'
    ]
  },
  {
    id: 17,
    name: 'Çanakkale',
    ilceler: [
      'Ayvacık', 'Bayramiç', 'Biga', 'Bozcaada', 'Çan', 'Çanakkale Merkez',
      'Eceabat', 'Ezine', 'Gelibolu', 'Gökçeada', 'Lapseki', 'Yenice'
    ]
  },
  {
    id: 18,
    name: 'Çankırı',
    ilceler: [
      'Atkaracalar', 'Bayramören', 'Çankırı Merkez', 'Eldivan', 'Ilgaz',
      'Kızılırmak', 'Korgun', 'Kurşunlu', 'Orta', 'Şabanözü', 'Yapraklı'
    ]
  },
  {
    id: 19,
    name: 'Çorum',
    ilceler: [
      'Alaca', 'Bayat', 'Boğazkale', 'Çorum Merkez', 'Dodurga', 'İskilip',
      'Kargı', 'Laçin', 'Mecitözü', 'Oğuzlar', 'Ortaköy', 'Osmancık',
      'Sungurlu', 'Uğurludağ'
    ]
  },
  {
    id: 20,
    name: 'Denizli',
    ilceler: [
      'Acıpayam', 'Babadağ', 'Baklan', 'Bekilli', 'Beyağaç', 'Bozkurt',
      'Buldan', 'Çal', 'Çameli', 'Çardak', 'Çivril', 'Güney',
      'Honaz', 'Kale', 'Merkezefendi', 'Pamukkale', 'Sarayköy', 'Serinhisar',
      'Tavas'
    ]
  },
  {
    id: 21,
    name: 'Diyarbakır',
    ilceler: [
      'Bağlar', 'Bismil', 'Çermik', 'Çınar', 'Çüngüş', 'Dicle',
      'Eğil', 'Ergani', 'Hani', 'Hazro', 'Kayapınar', 'Kocaköy',
      'Kulp', 'Lice', 'Silvan', 'Sur', 'Yenişehir'
    ]
  },
  {
    id: 22,
    name: 'Edirne',
    ilceler: [
      'Edirne Merkez', 'Enez', 'Havsa', 'İpsala', 'Keşan', 'Lalapaşa',
      'Meriç', 'Süloğlu', 'Uzunköprü'
    ]
  },
  {
    id: 23,
    name: 'Elazığ',
    ilceler: [
      'Ağın', 'Alacakaya', 'Arıcak', 'Baskil', 'Elazığ Merkez', 'Karakoçan',
      'Keban', 'Kovancılar', 'Maden', 'Palu', 'Sivrice'
    ]
  },
  {
    id: 24,
    name: 'Erzincan',
    ilceler: [
      'Çayırlı', 'Erzincan Merkez', 'İliç', 'Kemah', 'Kemaliye', 'Otlukbeli',
      'Refahiye', 'Tercan', 'Üzümlü'
    ]
  },
  {
    id: 25,
    name: 'Erzurum',
    ilceler: [
      'Aşkale', 'Aziziye', 'Çat', 'Hınıs', 'Horasan', 'İspir',
      'Karaçoban', 'Karayazı', 'Köprüköy', 'Narman', 'Oltu', 'Olur',
      'Palandöken', 'Pasinler', 'Pazaryolu', 'Şenkaya', 'Tekman',
      'Tortum', 'Uzundere', 'Yakutiye'
    ]
  },
  {
    id: 26,
    name: 'Eskişehir',
    ilceler: [
      'Alpu', 'Beylikova', 'Çifteler', 'Günyüzü', 'Han', 'İnönü',
      'Mahmudiye', 'Mihalgazi', 'Mihalıççık', 'Odunpazarı', 'Sarıcakaya',
      'Seyitgazi', 'Sivrihisar', 'Tepebaşı'
    ]
  },
  {
    id: 27,
    name: 'Gaziantep',
    ilceler: [
      'Araban', 'İslahiye', 'Karkamış', 'Nizip', 'Nurdağı', 'Oğuzeli',
      'Şahinbey', 'Şehitkamil', 'Yavuzeli'
    ]
  },
  {
    id: 28,
    name: 'Giresun',
    ilceler: [
      'Alucra', 'Bulancak', 'Çamoluk', 'Çanakçı', 'Dereli', 'Doğankent',
      'Espiye', 'Eynesil', 'Giresun Merkez', 'Görele', 'Güce', 'Keşap',
      'Piraziz', 'Şebinkarahisar', 'Tirebolu', 'Yağlıdere'
    ]
  },
  {
    id: 29,
    name: 'Gümüşhane',
    ilceler: [
      'Gümüşhane Merkez', 'Kelkit', 'Köse', 'Kürtün', 'Şiran', 'Torul'
    ]
  },
  {
    id: 30,
    name: 'Hakkari',
    ilceler: [
      'Çukurca', 'Derecik', 'Hakkari Merkez', 'Şemdinli', 'Yüksekova'
    ]
  },
  {
    id: 31,
    name: 'Hatay',
    ilceler: [
      'Altınözü', 'Antakya', 'Arsuz', 'Belen', 'Defne', 'Dörtyol',
      'Erzin', 'Hassa', 'İskenderun', 'Kırıkhan', 'Kumlu', 'Payas',
      'Reyhanlı', 'Samandağ', 'Yayladağı'
    ]
  },
  {
    id: 32,
    name: 'Isparta',
    ilceler: [
      'Aksu', 'Atabey', 'Eğirdir', 'Gelendost', 'Gönen', 'Keçiborlu',
      'Isparta Merkez', 'Senirkent', 'Sütçüler', 'Şarkikaraağaç', 'Uluborlu',
      'Yalvaç', 'Yenişarbademli'
    ]
  },
  {
    id: 33,
    name: 'Mersin',
    ilceler: [
      'Akdeniz', 'Anamur', 'Aydıncık', 'Bozyazı', 'Çamlıyayla', 'Erdemli',
      'Gülnar', 'Mezitli', 'Mut', 'Silifke', 'Tarsus', 'Toroslar',
      'Yenişehir'
    ]
  },
  {
    id: 34,
    name: 'İstanbul',
    ilceler: [
      'Adalar', 'Arnavutköy', 'Ataşehir', 'Avcılar', 'Bağcılar', 'Bahçelievler',
      'Bakırköy', 'Başakşehir', 'Bayrampaşa', 'Beşiktaş', 'Beykoz', 'Beylikdüzü',
      'Beyoğlu', 'Büyükçekmece', 'Çatalca', 'Çekmeköy', 'Esenler', 'Esenyurt',
      'Eyüpsultan', 'Fatih', 'Gaziosmanpaşa', 'Güngören', 'Kadıköy', 'Kağıthane',
      'Kartal', 'Küçükçekmece', 'Maltepe', 'Pendik', 'Sancaktepe', 'Sarıyer',
      'Silivri', 'Sultanbeyli', 'Sultangazi', 'Şile', 'Şişli', 'Tuzla',
      'Ümraniye', 'Üsküdar', 'Zeytinburnu'
    ]
  },
  {
    id: 35,
    name: 'İzmir',
    ilceler: [
      'Aliağa', 'Balçova', 'Bayındır', 'Bayraklı', 'Bergama', 'Beydağ',
      'Bornova', 'Buca', 'Çeşme', 'Çiğli', 'Dikili', 'Foça',
      'Gaziemir', 'Güzelbahçe', 'Karabağlar', 'Karaburun', 'Karşıyaka', 'Kemalpaşa',
      'Kınık', 'Kiraz', 'Konak', 'Menderes', 'Menemen', 'Narlıdere',
      'Ödemiş', 'Seferihisar', 'Selçuk', 'Tire', 'Torbalı', 'Urla'
    ]
  },
  {
    id: 36,
    name: 'Kars',
    ilceler: [
      'Akyaka', 'Arpaçay', 'Digor', 'Kağızman', 'Kars Merkez', 'Sarıkamış',
      'Selim', 'Susuz'
    ]
  },
  {
    id: 37,
    name: 'Kastamonu',
    ilceler: [
      'Abana', 'Ağlı', 'Araç', 'Azdavay', 'Bozkurt', 'Cide',
      'Çatalzeytin', 'Daday', 'Devrekani', 'Doğanyurt', 'Hanönü', 'İhsangazi',
      'İnebolu', 'Kastamonu Merkez', 'Küre', 'Pınarbaşı', 'Seydiler', 'Şenpazar',
      'Taşköprü', 'Tosya'
    ]
  },
  {
    id: 38,
    name: 'Kayseri',
    ilceler: [
      'Akkışla', 'Bünyan', 'Develi', 'Felahiye', 'Hacılar', 'İncesu',
      'Kocasinan', 'Melikgazi', 'Özvatan', 'Pınarbaşı', 'Sarıoğlan', 'Sarız',
      'Talas', 'Tomarza', 'Yahyalı', 'Yeşilhisar'
    ]
  },
  {
    id: 39,
    name: 'Kırklareli',
    ilceler: [
      'Babaeski', 'Demirköy', 'Kırklareli Merkez', 'Kofçaz', 'Lüleburgaz',
      'Pehlivanköy', 'Pınarhisar', 'Vize'
    ]
  },
  {
    id: 40,
    name: 'Kırşehir',
    ilceler: [
      'Akçakent', 'Akpınar', 'Boztepe', 'Çiçekdağı', 'Kaman', 'Kırşehir Merkez',
      'Mucur'
    ]
  },
  {
    id: 41,
    name: 'Kocaeli',
    ilceler: [
      'Başiskele', 'Çayırova', 'Darıca', 'Derince', 'Dilovası', 'Gebze',
      'Gölcük', 'İzmit', 'Kandıra', 'Karamürsel', 'Kartepe', 'Körfez'
    ]
  },
  {
    id: 42,
    name: 'Konya',
    ilceler: [
      'Ahırlı', 'Akören', 'Akşehir', 'Altınekin', 'Beyşehir', 'Bozkır',
      'Cihanbeyli', 'Çeltik', 'Çumra', 'Derbent', 'Derebucak', 'Doğanhisar',
      'Emirgazi', 'Ereğli', 'Güneysinir', 'Hadim', 'Halkapınar', 'Hüyük',
      'Ilgın', 'Kadınhanı', 'Karapınar', 'Karatay', 'Kulu', 'Meram',
      'Sarayönü', 'Selçuklu', 'Seydişehir', 'Taşkent', 'Tuzlukçu', 'Yalıhüyük',
      'Yunak'
    ]
  },
  {
    id: 43,
    name: 'Kütahya',
    ilceler: [
      'Altıntaş', 'Aslanapa', 'Çavdarhisar', 'Domaniç', 'Dumlupınar', 'Emet',
      'Gediz', 'Hisarcık', 'Kütahya Merkez', 'Pazarlar', 'Şaphane', 'Simav',
      'Tavşanlı'
    ]
  },
  {
    id: 44,
    name: 'Malatya',
    ilceler: [
      'Akçadağ', 'Arapgir', 'Arguvan', 'Battalgazi', 'Darende', 'Doğanşehir',
      'Doğanyol', 'Hekimhan', 'Kale', 'Kuluncak', 'Pütürge', 'Yazıhan',
      'Yeşilyurt'
    ]
  },
  {
    id: 45,
    name: 'Manisa',
    ilceler: [
      'Ahmetli', 'Akhisar', 'Alaşehir', 'Demirci', 'Gölmarmara', 'Gördes',
      'Kırkağaç', 'Köprübaşı', 'Kula', 'Salihli', 'Sarıgöl', 'Saruhanlı',
      'Selendi', 'Soma', 'Şehzadeler', 'Turgutlu', 'Yunusemre'
    ]
  },
  {
    id: 46,
    name: 'Kahramanmaraş',
    ilceler: [
      'Afşin', 'Andırın', 'Çağlayancerit', 'Dulkadiroğlu', 'Ekinözü', 'Elbistan',
      'Göksun', 'Nurhak', 'Onikişubat', 'Pazarcık', 'Türkoğlu'
    ]
  },
  {
    id: 47,
    name: 'Mardin',
    ilceler: [
      'Artuklu', 'Dargeçit', 'Derik', 'Kızıltepe', 'Mazıdağı', 'Midyat',
      'Nusaybin', 'Ömerli', 'Savur', 'Yeşilli'
    ]
  },
  {
    id: 48,
    name: 'Muğla',
    ilceler: [
      'Bodrum', 'Dalaman', 'Datça', 'Fethiye', 'Kavaklıdere', 'Köyceğiz',
      'Marmaris', 'Menteşe', 'Milas', 'Ortaca', 'Seydikemer', 'Ula',
      'Yatağan'
    ]
  },
  {
    id: 49,
    name: 'Muş',
    ilceler: [
      'Bulanık', 'Hasköy', 'Korkut', 'Malazgirt', 'Muş Merkez', 'Varto'
    ]
  },
  {
    id: 50,
    name: 'Nevşehir',
    ilceler: [
      'Acıgöl', 'Avanos', 'Derinkuyu', 'Gülşehir', 'Hacıbektaş', 'Kozaklı',
      'Nevşehir Merkez', 'Ürgüp'
    ]
  },
  {
    id: 51,
    name: 'Niğde',
    ilceler: [
      'Altunhisar', 'Bor', 'Çamardı', 'Çiftlik', 'Niğde Merkez', 'Ulukışla'
    ]
  },
  {
    id: 52,
    name: 'Ordu',
    ilceler: [
      'Akkuş', 'Altınordu', 'Aybastı', 'Çamaş', 'Çatalpınar', 'Çaybaşı',
      'Fatsa', 'Gölköy', 'Gülyalı', 'Gürgentepe', 'İkizce', 'Kabadüz',
      'Kabataş', 'Korgan', 'Kumru', 'Mesudiye', 'Perşembe', 'Ulubey',
      'Ünye'
    ]
  },
  {
    id: 53,
    name: 'Rize',
    ilceler: [
      'Ardeşen', 'Çamlıhemşin', 'Çayeli', 'Derepazarı', 'Fındıklı', 'Güneysu',
      'Hemşin', 'İkizdere', 'İyidere', 'Kalkandere', 'Pazar', 'Rize Merkez'
    ]
  },
  {
    id: 54,
    name: 'Sakarya',
    ilceler: [
      'Adapazarı', 'Akyazı', 'Arifiye', 'Erenler', 'Ferizli', 'Geyve',
      'Hendek', 'Karapürçek', 'Karasu', 'Kaynarca', 'Kocaali', 'Pamukova',
      'Sapanca', 'Serdivan', 'Söğütlü', 'Taraklı'
    ]
  },
  {
    id: 55,
    name: 'Samsun',
    ilceler: [
      'Alaçam', 'Asarcık', 'Atakum', 'Ayvacık', 'Bafra', 'Canik',
      'Çarşamba', 'Havza', 'İlkadım', 'Kavak', 'Ladik', 'Ondokuzmayıs',
      'Salıpazarı', 'Tekkeköy', 'Terme', 'Vezirköprü', 'Yakakent'
    ]
  },
  {
    id: 56,
    name: 'Siirt',
    ilceler: [
      'Baykan', 'Eruh', 'Kurtalan', 'Pervari', 'Siirt Merkez', 'Şirvan',
      'Tillo'
    ]
  },
  {
    id: 57,
    name: 'Sinop',
    ilceler: [
      'Ayancık', 'Boyabat', 'Dikmen', 'Durağan', 'Erfelek', 'Gerze',
      'Saraydüzü', 'Sinop Merkez', 'Türkeli'
    ]
  },
  {
    id: 58,
    name: 'Sivas',
    ilceler: [
      'Akıncılar', 'Altınyayla', 'Divriği', 'Doğanşar', 'Gemerek', 'Gölova',
      'Gömeç', 'Gürun', 'Hafik', 'İmranlı', 'Kangal', 'Koyulhisar',
      'Şarkışla', 'Sivas Merkez', 'Suşehri', 'Ulaş', 'Yıldızeli', 'Zara'
    ]
  },
  {
    id: 59,
    name: 'Tekirdağ',
    ilceler: [
      'Çerkezköy', 'Çorlu', 'Ergene', 'Hayrabolu', 'Kapaklı', 'Malkara',
      'Marmaraereğlisi', 'Muratlı', 'Saray', 'Süleymanpaşa', 'Şarköy'
    ]
  },
  {
    id: 60,
    name: 'Tokat',
    ilceler: [
      'Almus', 'Artova', 'Başçiftlik', 'Erbaa', 'Niksar', 'Pazar',
      'Reşadiye', 'Sulusaray', 'Tokat Merkez', 'Turhal', 'Yeşilyurt', 'Zile'
    ]
  },
  {
    id: 61,
    name: 'Trabzon',
    ilceler: [
      'Akçaabat', 'Araklı', 'Arsin', 'Beşikdüzü', 'Çarşıbaşı', 'Çaykara',
      'Dernekpazarı', 'Düzköy', 'Hayrat', 'Köprübaşı', 'Maçka', 'Of',
      'Ortahisar', 'Sürmene', 'Şalpazarı', 'Tonya', 'Vakfıkebir', 'Yomra'
    ]
  },
  {
    id: 62,
    name: 'Tunceli',
    ilceler: [
      'Çemişgezek', 'Hozat', 'Mazgirt', 'Nazımiye', 'Ovacık', 'Pertek',
      'Pülümür', 'Tunceli Merkez'
    ]
  },
  {
    id: 63,
    name: 'Şanlıurfa',
    ilceler: [
      'Akçakale', 'Birecik', 'Bozova', 'Ceylanpınar', 'Eyyübiye', 'Halfeti',
      'Haliliye', 'Harran', 'Hilvan', 'Karaköprü', 'Siverek', 'Suruç',
      'Viranşehir'
    ]
  },
  {
    id: 64,
    name: 'Uşak',
    ilceler: [
      'Banaz', 'Eşme', 'Karahallı', 'Sivaslı', 'Ulubey', 'Uşak Merkez'
    ]
  },
  {
    id: 65,
    name: 'Van',
    ilceler: [
      'Bahçesaray', 'Başkale', 'Çaldıran', 'Çatak', 'Edremit', 'Erciş',
      'Gevaş', 'Gürpınar', 'İpekyolu', 'Muradiye', 'Özalp', 'Saray',
      'Tuşba'
    ]
  },
  {
    id: 66,
    name: 'Yozgat',
    ilceler: [
      'Akdağmadeni', 'Aydıncık', 'Boğazlıyan', 'Çandır', 'Çayıralan', 'Çekerek',
      'Kadışehri', 'Saraykent', 'Sarıkaya', 'Sorgun', 'Şefaatli', 'Yenifakılı',
      'Yerköy', 'Yozgat Merkez'
    ]
  },
  {
    id: 67,
    name: 'Zonguldak',
    ilceler: [
      'Alaplı', 'Çaycuma', 'Devrek', 'Gökçebey', 'Kilimli', 'Kozlu',
      'Zonguldak Merkez'
    ]
  },
  {
    id: 68,
    name: 'Aksaray',
    ilceler: [
      'Ağaçören', 'Aksaray Merkez', 'Eskil', 'Gülağaç', 'Güzelyurt',
      'Ortaköy', 'Sarıyahşi', 'Sultanhanı'
    ]
  },
  {
    id: 69,
    name: 'Bayburt',
    ilceler: [
      'Aydıntepe', 'Bayburt Merkez', 'Demirözü'
    ]
  },
  {
    id: 70,
    name: 'Karaman',
    ilceler: [
      'Ayrancı', 'Başyayla', 'Ermenek', 'Karaman Merkez', 'Kazımkarabekir',
      'Sarıveliler'
    ]
  },
  {
    id: 71,
    name: 'Kırıkkale',
    ilceler: [
      'Bahşili', 'Balışeyh', 'Çelebi', 'Delice', 'Karakeçili', 'Keskin',
      'Kırıkkale Merkez', 'Sulakyurt', 'Yahşihan'
    ]
  },
  {
    id: 72,
    name: 'Batman',
    ilceler: [
      'Batman Merkez', 'Beşiri', 'Gercüş', 'Hasankeyf', 'Kozluk', 'Sason'
    ]
  },
  {
    id: 73,
    name: 'Şırnak',
    ilceler: [
      'Beytüşşebap', 'Cizre', 'Güçlükonak', 'İdil', 'Silopi', 'Şırnak Merkez',
      'Uludere'
    ]
  },
  {
    id: 74,
    name: 'Bartın',
    ilceler: [
      'Arit', 'Bartın Merkez', 'Kurucaşile', 'Ulus'
    ]
  },
  {
    id: 75,
    name: 'Ardahan',
    ilceler: [
      'Ardahan Merkez', 'Çıldır', 'Damal', 'Göle', 'Hanak', 'Posof'
    ]
  },
  {
    id: 76,
    name: 'Iğdır',
    ilceler: [
      'Aralık', 'Iğdır Merkez', 'Karakoyunlu', 'Tuzluca'
    ]
  },
  {
    id: 77,
    name: 'Yalova',
    ilceler: [
      'Altınova', 'Armutlu', 'Çiftlikköy', 'Çınarcık', 'Termal', 'Yalova Merkez'
    ]
  },
  {
    id: 78,
    name: 'Karabük',
    ilceler: [
      'Eflani', 'Eskipazar', 'Karabük Merkez', 'Ovacık', 'Safranbolu', 'Yenice'
    ]
  },
  {
    id: 79,
    name: 'Kilis',
    ilceler: [
      'Elbeyli', 'Kilis Merkez', 'Musabeyli', 'Polateli'
    ]
  },
  {
    id: 80,
    name: 'Osmaniye',
    ilceler: [
      'Bahçe', 'Düziçi', 'Hasanbeyli', 'Kadirli', 'Osmaniye Merkez', 'Sumbas',
      'Toprakkale'
    ]
  },
  {
    id: 81,
    name: 'Düzce',
    ilceler: [
      'Akçakoca', 'Cumayeri', 'Çilimli', 'Düzce Merkez', 'Gölköy', 'Gölyaka',
      'Kaynaşlı', 'Yığılca'
    ]
  }
];
